module.exports = __webpack_public_path__ + "img/symbol_3.c263a604.png";